export default __webpack_public_path__ + "static/media/wave4 (3).4baea6f5.svg";